/* svg-properties.js */
const DEFAULT_IMAGE_URL = "/images/svg_sprite.svg";
const MERX_IMAGE_URL = "/cms-portals/MERX/images/merx_sprite.svg";

export const svgProps: any = {
    svg_error: {
        viewbox: "600 600 42 42",
        imageUrl: DEFAULT_IMAGE_URL,
        imageId: "exclamationCircle"
    },
    svg_warning: {
        viewbox: "600 600 42 42",
        imageUrl: DEFAULT_IMAGE_URL,
        imageId: "exclamationCircle"
    },
    svg_success: {
        viewbox: "650 250 20 20",
        imageUrl: DEFAULT_IMAGE_URL,
        imageId: "checkmarkCircle"
    },
    svg_info: {
        viewbox: "650 300 20 20",
        imageUrl: DEFAULT_IMAGE_URL,
        imageId: "info2"
    },
    svg_VISA: {
        viewbox: "650 50 48 32",
        imageUrl: DEFAULT_IMAGE_URL,
        imageId: "simpleVisa"
    },
    svg_MC: {
        viewbox: "650 100 48 32",
        imageUrl: DEFAULT_IMAGE_URL,
        imageId: "simpleMasterCard"
    },
    svg_color_MC: {
        viewbox: "650 500 48 32",
        imageUrl: DEFAULT_IMAGE_URL,
        imageId: "colorMasterCard"
    },
    svg_AE: {
        viewbox: "650 150 48 32",
        imageUrl: DEFAULT_IMAGE_URL,
        imageId: "simpleAE"
    },
    svg_checkmarkCircle3: {
        viewbox: "650 200 32 32",
        imageUrl: DEFAULT_IMAGE_URL,
        imageId: "checkmarkCircle3"
    },
    svg_close: {
        viewbox: "600 550 22 22",
        imageUrl: DEFAULT_IMAGE_URL,
        imageId: "dialogClose"
    },
    svg_help: {
        viewbox: "650 0 20 20",
        imageUrl: DEFAULT_IMAGE_URL,
        imageId: "helpCircle"
    },
    svg_eye: {
        viewbox: "650 450 20 15",
        imageUrl: DEFAULT_IMAGE_URL,
        imageId: "eye"
    },
    svg_eye_hide: {
        viewbox: "650 550 24 24",
        imageUrl: DEFAULT_IMAGE_URL,
        imageId: "eyeHide"
    },
    svg_circle_checkmark_thin: {
        viewbox: "650 250 20 20",
        imageUrl: DEFAULT_IMAGE_URL,
        imageId: "checkmarkCircle"
    },
    svg_plus_thin: {
        viewbox: "400 100 20 20",
        imageUrl: DEFAULT_IMAGE_URL,
        imageId: "plusIcon"
    },
    svg_maple_leaf: {
        viewbox: "0 0 38 42",
        imageUrl: MERX_IMAGE_URL,
        imageId: "mapleLeaf"
    },
    svg_PC: {
        viewbox: "50 0 44 38",
        imageUrl: MERX_IMAGE_URL,
        imageId: "privateConstruction"
    },
    svg_UST: {
        viewbox: "150 0 36 30",
        imageUrl: MERX_IMAGE_URL,
        imageId: "usTender"
    },
    svg_xIcon: {
        viewbox: "50 100 16 16",
        imageUrl: DEFAULT_IMAGE_URL,
        imageId: "xIcon"
    },
    svg_checkmarkCircle4: {
        viewbox: "700 650 36 36",
        imageUrl: DEFAULT_IMAGE_URL,
        imageId: "checkmarkCircle4"
    },
    svg_statesMap: {
        viewbox: "100 0 40 37",
        imageUrl: DEFAULT_IMAGE_URL,
        imageId: "statesMap"
    },
    svg_search: {
        viewbox: "50 0 22 22",
        imageUrl: DEFAULT_IMAGE_URL,
        imageId: "magnifyingGlass"
    },
    svg_megaphoneWithCircle: {
        viewbox: "200 50 38 38",
        imageUrl: DEFAULT_IMAGE_URL,
        imageId: "megaphoneWithCircle"
    },
    svg_tag: {
        viewbox: "600 350 18 18",
        imageUrl: DEFAULT_IMAGE_URL,
        imageId: "tag"
    }
};
